// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"5eb6de80","1395":"5eb6de80","5309":"5eb6de80","5871":"5eb6de80","6761":"5eb6de80","8190":"5eb6de80","8925":"5eb6de80"}[chunkId] + ".chunk.css";
};